function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M6 .75c1.392 0 2.728.553 3.712 1.538.985.984 1.538 2.32 1.538 3.712 0 2.9-2.35 5.25-5.25 5.25S.75 8.9.75 6 3.1.75 6 .75zm0 .75C3.515 1.5 1.5 3.515 1.5 6s2.015 4.5 4.5 4.5c1.193 0 2.338-.474 3.182-1.318C10.026 8.338 10.5 7.193 10.5 6c0-2.485-2.015-4.5-4.5-4.5zm1.327 2.644l.53.529L6.528 6l1.327 1.327-.529.53L6 6.528 4.673 7.856l-.53-.529L5.472 6 4.144 4.673l.529-.53L6 5.472l1.327-1.327z",
  transform: "translate(-790 -6011) translate(790 6011)"
}))));

var SvgCanceled = function SvgCanceled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCanceled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/canceled.b907df53.svg";
export { ForwardRef as ReactComponent };